import * as Yup from 'yup'
import {useFormik} from 'formik'
import {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import apiConnect from '../../api/apiConnect'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {useUser} from '../../modules/newauth/UserContext'
import Select from 'react-select'

const profileDetailsSchema = Yup.object().shape({
  deviceName: Yup.string().required('Device name is required'),
})

const options = [
  {value: '', label: 'Select a device type...'},
  {value: 'mercury', label: 'Mercury'},
  {value: 'stellar', label: 'Stellar'},
]

const iotOptions = [{value: 'clearblade', label: 'Clear Blade'}]

const cloudRegionOptions = [
  {value: 'asia-east1', label: 'Asia East 1'},
  {value: 'us-central1', label: 'US Central 1'},
]

const limitParameterOptions = [
  {value: 20, label: '20'},
  {value: 40, label: '40'},
  {value: 60, label: '60'},
]

const CreateNewDevice = () => {
  const [deviceType, setDeviceType] = useState('')
  const navigate = useNavigate()
  const {user} = useUser()

  const [cloudRegions, setCloudRegions] = useState('asia-east1')
  const [registry, setRegistry] = useState([])

  const formik = useFormik({
    initialValues: {
      deviceName: '',
      ownerId: user.userIdMalin1,
      gatewayId: '',
      gatewayCode: '',
      registryId: '',
      alarmEmailLinePerDay: 20,
      alarmDay: 56,
      deviceManufacturer: 'Z4jcu5YBOZtqBuUhvyNj',
      deviceModel: 'FJ1M7uLiHrXYzOrAxxYX',
      status: 'offline',
      lastStatus: 'offline',
      premium: false,
      transactionCount: 0,
      cloudRegion: 'asia-east1',
      iotCore: 'clearblade',
      limitParameter: 20,
    },
    validationSchema: profileDetailsSchema,
    onSubmit: async (values) => {
      Swal.fire({
        title: 'Creating new parameter...',
        html: 'Please wait a moment.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        },
      })

      const payload = {
        cloud_region: values.cloudRegion,
        gateway_code: values.gatewayCode,
        gateway_id: values.gatewayId,
        iot: values.iotCore,
        name: values.deviceName,
        owner: values.ownerId,
        registry_id: values.registryId,
        type: deviceType,
        limitParameter: values.limitParameter,
      }

      console.log(payload)

      try {
        const response = await apiConnect.post('/v1/devices/create-new-device', payload)

        if (response.data.status == 'success') {
          const payloadClearBlade = {
            // deviceId: response.data.data.deviceId,
            deviceId: values.gatewayId,
            cloudRegion: values.cloudRegion,
            registryId: values.registryId,
          }

          try {
            const response2 = await apiConnect.post('/v1/generateKeys', payloadClearBlade)

            console.log(response2)

            const payloadUpdateDevice = {
              deviceId: response.data.data.deviceId,
              publicKey: response2.data.publicKey,
              privateKey: response2.data.privateKey,
              linkWithClearBlade: true,
              gatewayId: response.data.data.deviceId,
            }

            try {
              const response3 = await apiConnect.post('/v1/devices/update-device', payloadUpdateDevice)

              console.log(response3)

              Swal.fire({
                icon: 'success',
                title: 'Create new device successfully!',
                width: '50%',
                html: `
                  <style>
                    table, th, td {
                      border: 1px solid black;
                      border-collapse: collapse;
                    }
                    th {
                      text-align: left;
                      background-color: #f0f0f0;
                      white-space: nowrap;
                    }
                    td {
                      text-align: right;
                    }
                    th, td {
                      padding: 8px;
                    }
                  </style>
                  <div>
                    <p>Device ID : ${response?.data?.data?.deviceId}</p>
                    <center>
                    <table>
                      <tbody>
                        <tr>
                          <th>MQTT_CLIENT_ID</th>
                          <td>${response2?.data?.name}</td>
                        </tr>
                        <tr>
                          <th>RSA_PUBLIC</th>
                          <td>${response2?.data?.publicKey}</td>
                        </tr>
                        <tr>
                          <th>RSA_PRIVATE</th>
                          <td>${response2?.data?.privateKey}</td>
                        </tr>
                        <tr>
                          <th>DEV_ID</th>
                          <td>${response?.data?.data?.deviceId}</td>
                        </tr>
                      </tbody>
                    </table>
                    </center>
                  </div>
                `,
              }).then(() => {
                navigate(`/dashboard`)
              })

              // Swal.fire({
              //   icon: 'success',
              //   title: 'Create new device successfully!',
              //   html: `<div>
              //       <p>Device ID : ${response.data.data.deviceId}</p>
              //    </div>`,
              // }).then(() => {
              //   navigate(`/dashboard`)
              // })
            } catch (error) {
              console.log(error)
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Step 3 error.',
              })
            }
          } catch (error) {
            console.log(error)
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Step 2 error.',
            })
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Step 1 error.',
        })
      }
    },
  })

  useEffect(() => {
    if (user?.role == 'user') {
      Swal.fire({
        icon: 'error',
        title: `You don't have permission.`,
      }).then(navigate('/dashboard'))
    } else {
      fetchRegistry(formik.values.cloudRegion)
    }
  }, [formik.values.cloudRegion, deviceType])

  const handleChangeCloudRegion = async (value) => {
    setCloudRegions(value)
  }

  const fetchRegistry = async (region) => {
    try {
      Swal.fire({
        title: 'Loading...',
        text: 'Please wait a moment',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        },
      })

      const apiUrl = `https://iot.clearblade.com/api/v/4/webhook/execute/ceccf8af0cbee3879d9cebbf8bd101/cloudiot?parent=projects/dygistechplatform/locations/${region}`

      const response = await axios.get(apiUrl, {
        headers: {
          'ClearBlade-UserToken':
            'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOi0xLCJpYXQiOjE3MzQ1Nzc3NDUsInNpZCI6IjMwYmUxMDRkLWU5YWUtNDI1OC04NzBhLWJhNWVkNzE1NmNlZCIsInR0IjoxLCJ1aWQiOiJhMmI5OWNmNjBjOWNmYWQ4ODJhZmY4ODNjNjBkIiwidXQiOjJ9.vkBlr5iPleFmWHKI684dC123E29HzyE-E6nOXJfZnqo',
        },
      })

      const array = response.data.deviceRegistries
      let newRegistry = array.map((item) => item.id)
      let result = []
      if (deviceType === 'mercury') {
        result = newRegistry.filter((item) => item.includes('mercury'))
      } else if (deviceType === 'stellar') {
        result = newRegistry.filter((item) => item.includes('stellar'))
      } else {
        console.log('deviceType not found')
      }

      setRegistry(result)
      formik.setFieldValue('registryId', newRegistry[0] || '') // ตั้งค่า default ใน Formik
      Swal.close()
    } catch (error) {
      console.error('Error fetching registry:', error)
      Swal.close()
    }
  }

  const handleDeviceTypeChange = (selectedOption) => {
    setDeviceType(selectedOption.value)
  }

  // Swal.fire({
  //   icon: 'success',
  //   title: 'Create new device successfully!',
  //   width: '50%',
  //   html: `
  //     <style>
  //       table, th, td {
  //         border: 1px solid black;
  //         border-collapse: collapse;
  //       }
  //       th {
  //         text-align: left;
  //         background-color: #f0f0f0;
  //         white-space: nowrap;
  //       }
  //       td {
  //         text-align: right;
  //       }
  //       th, td {
  //         padding: 8px;
  //       }
  //     </style>
  //     <div>
  //       <p>Device ID : 123123123</p>
  //       <center>
  //       <table>
  //         <tbody>
  //           <tr>
  //             <th>MQTT_URL</th>
  //             <td>Tiger Nixon</td>
  //           </tr>
  //           <tr>
  //             <th>MQTT_CLIENT_ID</th>
  //             <td>System Architect</td>
  //           </tr>
  //           <tr>
  //             <th>SUB_CONF_TP</th>
  //             <td>Edinburgh</td>
  //           </tr>
  //           <tr>
  //             <th>SUB_CMD_TP</th>
  //             <td>61</td>
  //           </tr>
  //            <tr>
  //             <th>PUB_NOR_TP</th>
  //             <td>61</td>
  //           </tr>
  //           <tr>
  //             <th>PUB_ALM_TP</th>
  //             <td>61</td>
  //           </tr>
  //           <tr>
  //             <th>PUB_STA_TP</th>
  //             <td>61</td>
  //           </tr>
  //           <tr>
  //             <th>RSA_PRIVATE</th>
  //             <td>61</td>
  //           </tr>
  //           <tr>
  //             <th>DEV_ID</th>
  //             <td>61</td>
  //           </tr>
  //         </tbody>
  //       </table>
  //       </center>
  //     </div>
  //   `,
  // })

  return (
    <>
      <div className='d-flex flex-wrap flex-stack mb-6'>
        <h3 className='fw-bolder my-2'>Create new deivce</h3>

        <div className='d-flex my-2'>
          <ol className='breadcrumb text-muted fs-6 fw-bold'>
            <li className='breadcrumb-item pe-3'>
              <Link to={'/dashboard'} className='pe-3'>
                Home
              </Link>
            </li>

            <li className='breadcrumb-item px-3 text-muted'>Create new device</li>
          </ol>
        </div>
      </div>

      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Create new device</h3>
          </div>
        </div>

        <div className='collapse show'>
          <div className='card-body border-top p-9'>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                <span className='required'>Device Type</span>
              </label>

              <div className='col-lg-8 fv-row'>
                <Select
                  options={options} // ตัวเลือกที่ต้องการแสดง
                  value={options.find((option) => option.value === deviceType)} // กำหนดค่าปัจจุบัน
                  onChange={handleDeviceTypeChange} // กำหนด event เมื่อเปลี่ยนค่า
                  classNamePrefix='react-select' // เพื่อกำหนด style ให้ custom ได้ง่าย
                />
              </div>
            </div>

            {(deviceType === 'mercury' || deviceType === 'stellar') && (
              <form onSubmit={formik.handleSubmit} noValidate className='form'>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>Device icon</label>
                  <div className='col-lg-8'>
                    <div
                      className='image-input image-input-outline'
                      data-kt-image-input='true'
                      style={{
                        backgroundImage: `url(https://firebasestorage.googleapis.com/v0/b/dygistechplatform.appspot.com/o/device_icon%2FMercury%20icon.png?alt=media&token=662638b1-e36b-470d-9d5c-684f5beeca80)`,
                      }}
                    >
                      <div
                        className='image-input-wrapper w-125px h-125px'
                        style={{
                          backgroundImage: `url(https://firebasestorage.googleapis.com/v0/b/dygistechplatform.appspot.com/o/device_icon%2FMercury%20icon.png?alt=media&token=662638b1-e36b-470d-9d5c-684f5beeca80)`,
                        }}
                      ></div>
                    </div>
                  </div>
                </div>

                {/* Devicename */}
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                    Device Name
                  </label>

                  <div className='col-lg-8'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Device name'
                      {...formik.getFieldProps('deviceName')}
                    />
                    {formik.touched.deviceName && formik.errors.deviceName && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.deviceName}</div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Owner ID */}
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Owner ID</label>

                  <div className='col-lg-8'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Owner ID'
                      {...formik.getFieldProps('ownerId')}
                    />
                    {formik.touched.ownerId && formik.errors.ownerId && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.ownerId}</div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Gateway ID */}
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                    Gateway ID (Device ID in Clear Blade)
                  </label>

                  <div className='col-lg-8 fv-row'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Gateway ID'
                      {...formik.getFieldProps('gatewayId')}
                    />
                    {formik.touched.gatewayId && formik.errors.gatewayId && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.gatewayId}</div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Gateway Code */}
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>
                    <span className='required'>Gateway Code</span>
                  </label>

                  <div className='col-lg-8 fv-row'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Gateway code'
                      value={'-'}
                      disabled={true}
                    />
                  </div>
                </div>

                {/* IOT Core */}
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>IOT Core</label>
                  <div className='col-lg-8 fv-row'>
                    <Select
                      options={iotOptions} // ตัวเลือกที่จะแสดง
                      value={iotOptions.find((option) => option.value === formik.values.iotCore)} // ค่าปัจจุบันจาก Formik
                      onChange={(selectedOption) =>
                        formik.setFieldValue('iotCore', selectedOption.value)
                      } // อัปเดตค่าใน Formik
                      classNamePrefix='react-select' // เพื่อช่วย styling
                    />

                    {formik.touched.iotCore && formik.errors.iotCore && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.iotCore}</div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Cloud Region */}
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                    Cloud Region
                  </label>
                  <div className='col-lg-8 fv-row'>
                    <Select
                      options={cloudRegionOptions} // ตัวเลือก Cloud Region
                      value={cloudRegionOptions.find(
                        (option) => option.value === formik.values.cloudRegion
                      )} // ค่าปัจจุบัน
                      onChange={(selectedOption) => {
                        formik.setFieldValue('cloudRegion', selectedOption.value) // อัปเดต Formik
                        fetchRegistry(selectedOption.value) // ดึงข้อมูล Registry ใหม่เมื่อเปลี่ยน
                      }}
                      classNamePrefix='react-select' // เพื่อช่วย styling
                    />
                  </div>
                </div>

                {/* Registry ID */}
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>Registry ID</label>
                  <div className='col-lg-8 fv-row'>
                    <Select
                      options={registry.map((item) => ({value: item, label: item}))} // แปลง registry เป็นรูปแบบ { value, label }
                      value={
                        registry.find((item) => item === formik.values.registryId)
                          ? {value: formik.values.registryId, label: formik.values.registryId}
                          : null
                      }
                      onChange={(selectedOption) =>
                        formik.setFieldValue('registryId', selectedOption?.value || '')
                      } // อัปเดตค่าใน Formik
                      classNamePrefix='react-select' // เพื่อช่วยเรื่อง style
                    />
                  </div>
                </div>

                {/* Limit Parameter */}
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                    Limit Parameter
                  </label>
                  <div className='col-lg-8 fv-row'>
                    <Select
                      options={limitParameterOptions} // ตัวเลือกที่จะแสดง
                      value={limitParameterOptions.find(
                        (option) => option.value === formik.values.limitParameter
                      )}
                      onChange={(selectedOption) =>
                        formik.setFieldValue('limitParameter', selectedOption.value)
                      }
                      classNamePrefix='react-select' // เพื่อช่วย styling
                    />
                  </div>
                </div>

                <hr className='mb-8' />

                <h3 className='fw-bolder mb-8'>
                  Additional information{' '}
                  <span className='badge badge-light-danger fs-5'>( Cannot be edited )</span>
                </h3>

                <div className='row'>
                  <div className='col-12 col-md-6 row mb-6'>
                    <label className='col-lg-4 col-form-label fw-bold fs-6'>
                      Alarm Email/Line per Days
                    </label>

                    <div className='col-lg-7'>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid'
                        placeholder='Alarm Email/Line per Days'
                        {...formik.getFieldProps('alarmEmailLinePerDay')}
                        disabled={true}
                      />
                      {formik.touched.alarmEmailLinePerDay && formik.errors.alarmEmailLinePerDay && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik.errors.alarmEmailLinePerDay}</div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='col-12 col-md-6 row mb-6'>
                    <label className='col-lg-4 col-form-label  fw-bold fs-6'>Alarm Days</label>

                    <div className='col-lg-7'>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid'
                        placeholder='Alarm days'
                        {...formik.getFieldProps('alarmDay')}
                        disabled={true}
                      />
                      {formik.touched.alarmDay && formik.errors.alarmDay && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik.errors.alarmDay}</div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='col-12 col-md-6 row mb-6'>
                    <label className='col-lg-4 col-form-label fw-bold fs-6'>
                      Device Manufacturer
                    </label>

                    <div className='col-lg-7'>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid'
                        placeholder='Device manufacturer'
                        {...formik.getFieldProps('deviceManufacturer')}
                        disabled={true}
                      />
                      {formik.touched.deviceManufacturer && formik.errors.deviceManufacturer && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik.errors.deviceManufacturer}</div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='col-12 col-md-6 row mb-6'>
                    <label className='col-lg-4 col-form-label  fw-bold fs-6'>Device Model</label>

                    <div className='col-lg-7'>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid'
                        placeholder='Device model '
                        {...formik.getFieldProps('deviceModel')}
                        disabled={true}
                      />
                      {formik.touched.deviceModel && formik.errors.deviceModel && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik.errors.deviceModel}</div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='col-12 col-md-6 row mb-6'>
                    <label className='col-lg-4 col-form-label fw-bold fs-6'>Status</label>

                    <div className='col-lg-7'>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid'
                        placeholder='Status'
                        {...formik.getFieldProps('status')}
                        disabled={true}
                      />
                      {formik.touched.status && formik.errors.status && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik.errors.status}</div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='col-12 col-md-6 row mb-6'>
                    <label className='col-lg-4 col-form-label  fw-bold fs-6'>Last Status</label>

                    <div className='col-lg-7'>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid'
                        placeholder='Last status'
                        {...formik.getFieldProps('lastStatus')}
                        disabled={true}
                      />
                      {formik.touched.lastStatus && formik.errors.lastStatus && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik.errors.lastStatus}</div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='col-12 col-md-6 row mb-6'>
                    <label className='col-lg-4 col-form-label fw-bold fs-6'>Premium</label>

                    <div className='col-lg-7'>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid'
                        placeholder='Premium'
                        {...formik.getFieldProps('premium')}
                        disabled={true}
                      />
                      {formik.touched.premium && formik.errors.premium && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik.errors.premium}</div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='col-12 col-md-6 row mb-6'>
                    <label className='col-lg-4 col-form-label  fw-bold fs-6'>
                      Transaction Count
                    </label>

                    <div className='col-lg-7'>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid'
                        placeholder='Transaction count'
                        {...formik.getFieldProps('transactionCount')}
                        disabled={true}
                      />
                      {formik.touched.transactionCount && formik.errors.transactionCount && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik.errors.transactionCount}</div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className='card-footer d-flex justify-content-end py-6 px-9'>
                  <button type='submit' className='btn btn-primary'>
                    Create new device
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export {CreateNewDevice}
